import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'stats-card',
  templateUrl: './stats-card.component.html',
  styleUrls: ['./stats-card.component.css']
})
export class StatsCardComponent implements OnInit {

  @Input() mainStat: number | string
  @Input() color: string
  @Input() icon: string
  @Input() title:string
  @Input() lessThanText?: string
  @Input() lessThanPluralText?: string
  @Input() greaterThanText?: string
  @Input() greaterThanPluralText?: string
  @Input() zeroText?: string
  @Input() growthStat: number = 0
  @Input() percent: boolean = false
  @Input() large: boolean = false
  @Input() showGrowth: boolean = true

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/app/submission-details/stats-card/stats-card.component.ts